import React from 'react';
import PropTypes from 'prop-types';
import { TopToolbar, ListButton } from 'react-admin';

const LemmaActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} record={data} />
  </TopToolbar>
);

LemmaActions.propTypes = {
  basePath: PropTypes.string,
  data: PropTypes.shape({}),
};

LemmaActions.defaultProps = {
  basePath: '',
  data: {},
};

export default LemmaActions;
